import { Popover as MUIPopover, styled } from '@mui/material'
import useGetPopoverTemplate from '~/src/components/mui-wrappers/styled/popover/styles/useGetPopoverTemplate'

const Popover = styled(MUIPopover)(() => useGetPopoverTemplate().getComponentSx())

export default Popover
